export const ERROR_CODES = {
  NOTFOUND: 'Not Found',
}
